import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GhabzModel } from "../../../Api/Models/GhabzModel";
import DashboardLayout from "../../../Components/LayoutContainers/DashboardLayout";
import AppLoading from "../../../Components/MDLoading";
import DashboardNavbar from "../../../Components/Navbars/DashboardNavbar";
import { ErrorToaast } from "../../../utils/toast/Toast";

export default function EditGhabz() {
  const ghabzModel = new GhabzModel();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const search = window.location.search;

  const params = new URLSearchParams(search);

  let Id = params.get("id");
  useEffect(() => {
    ghabzModel
      .get(parseInt(Id ?? ""))
      .then((result) => {
        setLoading(false);
        // setData;
      })
      .catch((err) => {
        ErrorToaast("مشکل در برقراری ارتباط");
      });

    return () => {};
  }, []);

  // if (Id === null || Id === "") {
  //   navigate("notfound", { replace: true });
  //   return null;
  // }

  return (
    <DashboardLayout>
      <DashboardNavbar name={"ویرایش قبض"} />
      <AppLoading show={loading} />
    </DashboardLayout>
  );
}
